/**
 * Wire-level constants shared by the api and the SPA.
 *
 * Sources: docs/09-security-and-privacy.md §2 (cookie, CSRF, password policy),
 * docs/05-api-spec.md §1.4 (pagination), ADR-0007 (session mechanism).
 * See ARCHITECTURE.md §2.1 C5–C7 for the two spokes that disagreed and how.
 */
/** Session cookie name (ADR-0007). */
export const SESSION_COOKIE = 'famtree_session';
/**
 * `__Host-` prefixed variant (docs/09 §2.2). Requires Secure + Path=/ + no Domain,
 * so it is only usable over HTTPS; the api picks it whenever cookies are Secure.
 */
export const SESSION_COOKIE_SECURE = '__Host-famtree_session';
/** Custom header required on every mutating request (docs/09 §2.4, docs/05 §3.1). */
export const CSRF_HEADER = 'x-requested-with';
/**
 * Value the SPA sends. The api accepts any non-empty value: docs/05 §3.1 specifies
 * `XMLHttpRequest`, docs/09 §2.4 specifies `famtree`, and the security property
 * (a non-simple header forces a preflight the api never grants) holds either way.
 */
export const CSRF_HEADER_VALUE = 'famtree';
/** Password policy — docs/09 §2.1 (the stricter of the two documented floors). */
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 128;
/** Session lifetime — docs/09 §2.2. */
export const SESSION_SLIDING_DAYS = 30;
export const SESSION_ABSOLUTE_DAYS = 90;
/** Sliding expiry is refreshed at most this often (docs/09 §2.2). */
export const SESSION_REFRESH_INTERVAL_HOURS = 24;
/** Token TTLs — docs/09 §2.6 (invite), docs/05 §11.4 (reset). */
export const INVITE_TTL_DAYS = 7;
export const RESET_TTL_HOURS = 24;
/** Pagination — docs/05 §1.4. */
export const PAGE_LIMIT_DEFAULT = 25;
export const PAGE_LIMIT_MAX = 100;
/** Body caps — docs/05 §2.2 (`payload_too_large`). */
export const JSON_BODY_LIMIT_BYTES = 1_048_576;
export const PHOTO_BODY_LIMIT_BYTES = 26_214_400;
/** The api listens here inside the container (docker-compose healthcheck). */
export const API_PORT_DEFAULT = 3000;
/**
 * Governance rate limits — docs/07-governance-and-voting.md §8.4. Deliberately
 * code constants, not `settings` columns: the settings table is closed
 * (docs/02 §3.5) and family scale needs no tuning.
 */
export const MAX_OPEN_PROPOSALS_PER_USER = 20;
export const MAX_PROPOSAL_CREATES_PER_USER_PER_DAY = 50;
export const MAX_VOTE_RECASTS_PER_PROPOSAL_PER_SEAT = 20;
/** Vote comment cap — docs/02 §3.4, mirrored by `votes_comment_check`. */
export const VOTE_COMMENT_MAX_LENGTH = 1_000;
/**
 * `vote_needed` reminder offsets before `closes_at`, in days — docs/07 §9. The
 * hourly `proposal.expire` sweep sends one reminder per offset per seat.
 */
export const VOTE_REMINDER_DAYS = [7, 1];
//# sourceMappingURL=constants.js.map